import i18next from 'i18next';

i18next.addResources('en', 'AdelphiChecklistsMenu', {
  title: 'Checklists Menu',
  dailyAMStills: 'Daily AM Stills',
  dailyPMStills: 'Daily PM Stills',
  dailyAMMash: 'Daily AM Mash',
  dailyPMMash: 'Daily PM Mash',
  weeklyAMPMStills: 'Weekly AM/PM Stills',
  weeklyAMPMMash: 'Weekly AM/PM Mash'
});
